import React from 'react';
import PropTypes from 'prop-types';

import IconPhoto from 'components/icons/iconPhoto';
import IconUpload from 'components/icons/IconUpload';
import { colorBrand } from 'styles/layout/colors';

const DropzoneUploadLabel = ({
  allowMultiple = true,
  allowVideos = true,
  subLabel = '',
}) => (
  <div className="text-xs font-bold items-center text-brand flex flex-col justify-center px-4 py-6 [&_svg]:h-[30px] [&_svg]:mb-[5px] [&_svg]:align-middle [&_svg]:w-[35px]">
    <IconPhoto color={colorBrand} className="md:hidden" />
    <IconUpload color={colorBrand} className="max-[767px]:hidden" />

    <span>
      <span className="md:hidden">{`Take a photo${
        allowVideos ? ', video' : ''
      } or upload from your library`}</span>

      <span className="max-[767px]:hidden">{`Choose photo${
        allowMultiple ? 's' : ''
      }${allowVideos ? '/video' : ''} or drag and drop here`}</span>

      {subLabel}
    </span>
  </div>
);

DropzoneUploadLabel.propTypes = {
  allowMultiple: PropTypes.bool,
  allowVideos: PropTypes.bool,
  subLabel: PropTypes.string,
};

export default DropzoneUploadLabel;
